<template>
  <a-coursecard v-bind="$props">
    <template slot="actions" slot-scope="{}">
      <v-btn
        min-width="110px"
        color="grey"
        class="white--text"
        depressed
        :loading="loading"
        :disabled="loading"
        @click="$emit('approve', course)"
        >Approve</v-btn
      >
      <v-btn
        class="white--text"
        width="100"
        color="blue"
        depressed
        :loading="loading"
        :disabled="loading"
        @click="$emit('edit', course)"
        >Edit</v-btn
      >
      <v-spacer />
      <v-menu bottom offset-y left>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="show = !show" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="$emit('reject', course)" class="item">
            <v-list-item-title class="text-center">Reject</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </a-coursecard>
</template>
<style scoped>
.item {
  min-width: 150px;
}
</style>
<script>
import courseCard from "@/components/coursecard";

export default {
  components: {
    "a-coursecard": courseCard
  },
  props: ["course"],
  data: () => ({
    loading: false,
    loader: null,
    show: false
  }),
  methods: {
    onLoad() {
      const l = this.loader;
      this[l] = !this[l];
      console.log("Loading...");
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        console.log("done");
      }, 3000);
      this.loader = null;
    }
  }
};
</script>
